import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import User from 'src/app/interfaces/User';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { ForumService } from 'src/app/services/forum.service';
import { ProjectService } from 'src/app/services/project.service';
import { EventService } from 'src/app/services/event.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-single-member',
  templateUrl: './single-member.component.html',
  styleUrls: ['./single-member.component.scss'],
})
export class SingleMemberComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  member$: Observable<any>;
  member: User;
  memberProjects = [];
  discussionIds = [];
  discussionIds$ = new BehaviorSubject([]);
  memberDiscussions = [];
  memberEvents = [];
  memberInstitutions = [];

  projectLimit = 2;
  topicLimit = 5;
  eventLimit = 3;
  institutionLimit = 2;
  cardOptions = false;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private projectService: ProjectService,
    private forumService: ForumService,
    private eventService: EventService,
    private institutionService: InstitutionService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.analyticsService.event('member_profile_view');
    // Get member data
    this.member$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.userService.getUser(params.get('id')))
    );
    this.subscriptions.add(
      this.member$.subscribe((m) => {
        this.member = m;

        this.projectService.getCurrentUserProjects(this.member.projects).subscribe((projArr) => {
          if (projArr.length) {
            projArr.forEach((p$) => {
              p$.subscribe((p) => {
                if (p && this.member.projectRoles[p[0].id] && this.member.projectRoles[p[0].id].status === 'active') {
                  this.memberProjects.push(p[0]);
                }
              });
            });
          }
        });
        this.institutionService.getCurrentUserInstitutions(this.member.institutions).subscribe((instArr) => {
          if (instArr.length) {
            instArr.forEach((i$) => {
              i$.subscribe((i) => {
                if (i && this.member.institutionRoles[i[0].id].status === 'active') {
                  this.memberInstitutions.push(i[0]);
                }
              });
            });
          }
        });

        this.forumService.getUserDiscussions(this.member.uid).subscribe((discObs: any) => {
          if (discObs.length) {
            discObs.forEach((discArr$, i) => {
              discArr$.subscribe((disc) => {
                if (i === 0 && disc) {
                  this.memberDiscussions = this.memberDiscussions.concat(disc);
                } else if (i === 1 && disc) {
                  let dIds = disc.map((d) => d.discussion);
                  dIds.forEach((id) => {
                    if (this.discussionIds.indexOf(id) === -1) {
                      this.discussionIds.push(id);
                    }
                  });
                  this.discussionIds$.next(this.discussionIds);
                }
              });
            });
          }
        });
        this.discussionIds$.subscribe((dIds) => {
          dIds.forEach((id) => {
            if (this.memberDiscussions.length) {
              if (!this.memberDiscussions.some((d) => d.id === id)) {
                this.forumService.getDiscussion(id).then((disc: any) => {
                  if (disc) {
                    this.memberDiscussions.push(disc);
                    this.memberDiscussions.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
                  }
                });
              }
            } else {
              this.forumService.getDiscussion(id).then((disc: any) => {
                if (disc) {
                  this.memberDiscussions.push(disc);
                  this.memberDiscussions.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
                }
              });
            }
          });
        });

        this.eventService.getCurrentUserEvents(this.member.events).subscribe((eventsArr) => {
          if (eventsArr.length) {
            eventsArr.forEach((e$) => {
              e$.subscribe((e) => {
                if (e && !e[0].archived) {
                  this.memberEvents.push(e[0]);
                }
              });
            });
          }
        });
      })
    );

    // Get current user
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
  }

  showMore(type) {
    this[type + 'Limit'] += this[type + 'Limit'] % 2 === 0 || this[type + 'Limit'] % 3 === 0 ? 6 : 5;
  }
  trackEvent(name: string): void {
    this.analyticsService.event(name);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
